<template>
  <add-edit-defect></add-edit-defect>
</template>

<script>
import AddEditDefect from "@/layouts/components/masters/defects/addedit-defect.vue";
export default {
  components: {
    AddEditDefect
  }
};
</script>